/* eslint-disable */
import { theme } from 'antd';

export const Theme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    wireframe: false,
    colorPrimary: 'rgba(44, 182, 149, 1)',
    fontSize: 13
  },
  components: {
    Layout: {
      colorBgContainer: '#3F4357'
    },
    Menu: {
      itemBg: '#3F4357',
      radiusItem: 0,
      radiusSubMenuItem: 0,
      itemColor: '#DCDFEF',
      itemSelectedColor: '#FFFF',
      itemHoverColor: '#FFFF',
      // itemSelectedBg: '#313442',
      itemSelectedBg: '#313442'
    },
    Table: {
      colorTextHeading: 'rgba(122, 130, 139, 1)',
      fontSize: 13
    }
  }
};
